import {  createSlice } from "@reduxjs/toolkit";
import { userDetailsInitialState } from "./intialState";

const recruiterDetailsSlice = createSlice({
    name: "recruiterDetails",
    initialState: () => {
        const initialState = { ...userDetailsInitialState }
        return initialState
    },
    reducers: {
      setIsLoggedInSuccess:(state,action) => {
        let currentState = state
        currentState.isLoginSuccess = action.payload
      }
  
    },
});

export const {
    setIsLoggedInSuccess
} = recruiterDetailsSlice.actions;

export default recruiterDetailsSlice;